
















import { Component, Vue, Watch } from 'vue-property-decorator'
import Tabs from '@/app/ui/components/Tabs/index.vue'
import { Route } from 'vue-router'
import rescheduleController from '@/app/ui/controllers/ReschedulePickupController'
import PickupController from '@/app/ui/controllers/PickupController'

@Component({
  components: {
    Tabs,
  },
})
export default class EditManageDataMaster extends Vue {
  rescheduleController = rescheduleController
  currentTab = 0
  currentPeriod = ''

  itemTabs = [
    { label: 'CRRNFD', value: 0 },
    { label: 'Reschedule Pickup', value: 1 },
  ]

  created(): void {
    if(this.$route.fullPath.includes('reschedule') || this.$route.params.tab) {
      this.currentTab = 1
    }

    this.$router.push({ name: this.getTabRoute(this.currentTab) })
    rescheduleController.getCounter()
  }

  get totalStatusWaitingReschedule(): string {
    return `(${rescheduleController.totalStatusWaiting})`
  }

  get totalCRRNFDGroups(): string {
    return `(${PickupController.pickupNfdSummary.totalGroups})`;
  }

  private onTabsClick(tab: number): void {
    if(tab !== this.currentTab) {
      this.currentTab = tab
      this.itemTabs.forEach(item => {
        if (item.value === this.currentTab) {
          this.$router.push({ name: this.getTabRoute(item.value) })
        }
      })
    }
    if (tab === 1) {
      rescheduleController.getCounter()
    }
  }

  private getTabRoute(key: number): string {
    if (key === 0) {
      return 'ListPickupCRRNFD_V2'
    }
    if (key === 1) {
      return 'ListPickupCRRNFDReschedule_V2'
    }
    return ''
  }

  @Watch('$route', { deep: true })
  watchRouter(value: Route): void {
    if (value.query?.fromSidebar || !value.fullPath.includes('reschedule')) {
      this.currentTab = 0
    }
  }
}
